export default "__VITE_ASSET__xM$ieFCZ__"